<template>
    <div class="card wow fadeInRight" data-wow-delay="0.3s">
        <div class="card-body">
            <form @submit.prevent="submit">
                <div v-if="success" class="alert alert-success" role="alert">
                    <strong>Message Sent</strong> Thanks for your message. We'll be in touch soon.
                </div>
    
                <div class="md-form md-form-enquire">
                    <input type="text" name="name" value="" class="form-control" v-model="fields.name">
                    <label for="name" class="active">Name <span class="text-danger">*</span></label>
                    <div class="text-danger" v-if="errors && errors.name">{{ errors.name[0] }}</div>
                </div>

                <div class="md-form md-form-enquire">
                    <input type="text" name="email" class="form-control" v-model="fields.email">
                    <label for="email" class="active">Email <span class="text-danger">*</span></label>
                    <div class="text-danger" v-if="errors && errors.email">{{ errors.email[0] }}</div>
                </div>

                <div class="md-form md-form-enquire">
                    <textarea placeholder="Enter your message here..." name="message" id="message" cols="30" rows="10" class="form-control msg-box" v-model="fields.message"></textarea>
                    <div class="text-danger" v-if="errors && errors.message">{{ errors.message[0] }}</div>
                </div>

                <div class="text-center mt-4">
                    <button class="text-center btn submit-btn middle">Submit</button>
                </div>

                <div class="mt-4 google-recaptcha">
                  This site is protected by reCAPTCHA and the Google
                  <a href="https://policies.google.com/privacy?hl=en-GB" target="_blank">Privacy Policy</a> and
                  <a href="https://policies.google.com/terms?hl=en-GB" target="_blank">Terms of Service</a> apply.
                </div>
            </form>
        </div>
    </div>
</template>
<script src='https://www.google.com/recaptcha/api.js'></script>
<script>
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { 
  siteKey: "6Le1XFIeAAAAALRApEwMmuna9Ck0qTVNO8hDnAO5",
    loaderOptions: {
    autoHideBadge: true
  }
  });

export default {
  data() {
    return {
      fields: {},
      errors: {},
      success: false,
    }
  },
  methods: {
    submit() {
      this.errors = {};
      this.$recaptcha("login").then((token) => {
            axios.post('/contact-us', this.fields).then(response => {
            this.fields = {}; 
            this.success = true;
          }).catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors || {};
            }
          });
      });
    },
  },
}
</script>